import React, { useState, useEffect } from 'react';
import { Card, Button, Spinner, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api, { getMediaUrl } from '../../services/api';
import './ProjectMarquee.css';

const ProjectMarquee = () => {
    const [projectItems, setProjectItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await api.get('/projects/', { params: { featured: 'true' } });
                const data = response.data.results || response.data;
                if (Array.isArray(data)) {
                    setProjectItems(data);
                } else {
                    setProjectItems([]);
                }
            } catch (error) {
                console.error('Error fetching projects:', error);
                setProjectItems([]);
            } finally {
                setLoading(false);
            }
        };

        fetchProjects();
    }, []);

    if (loading) {
        return (
            <div className="d-flex justify-content-center py-5">
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (!Array.isArray(projectItems) || projectItems.length === 0) {
        return null;
    }

    // To make the marquee continuous, we duplicate the projects
    const marqueeProjects = [...projectItems, ...projectItems];

    return (
        <section className="projects-section homepage-section">
            <Container>
                <h2 className="section-title">Ongoing Projects</h2>
                <div className="project-marquee-container">
                    <div className="marquee-track">
                        {marqueeProjects.map((project, index) => (
                            <div key={`${project.id}-${index}`} className="project-card-wrapper">
                                <Card className="project-card h-100 shadow-sm border-0">
                                    <div className="project-image-wrapper">
                                        {project.image ? (
                                            <Card.Img
                                                variant="top"
                                                src={getMediaUrl(project.image)}
                                                alt={project.title}
                                                className="project-image"
                                            />
                                        ) : (
                                            <div className="project-image-placeholder">
                                                <i className="fas fa-building fa-3x text-muted"></i>
                                            </div>
                                        )}
                                        <div className={`project-status-badge ${project.status}`}>
                                            {project.status.charAt(0).toUpperCase() + project.status.slice(1).replace('_', ' ')}
                                        </div>
                                    </div>
                                    <Card.Body className="d-flex flex-column">
                                        <Card.Title className="project-title mb-2">
                                            {project.title}
                                        </Card.Title>
                                        <Card.Text className="project-summary text-muted mb-3 flex-grow-1">
                                            {project.summary}
                                        </Card.Text>
                                        <div className="mt-auto">
                                            <Link to={`/projects/${project.slug}`}>
                                                <Button variant="outline-primary" size="sm" className="read-more-btn">
                                                    Read More <i className="fas fa-arrow-right ms-1"></i>
                                                </Button>
                                            </Link>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="text-center mt-4">
                    <Link to="/projects" className="btn btn-primary">
                        View All Projects <i className="fas fa-arrow-right ms-2"></i>
                    </Link>
                </div>
            </Container>
        </section>
    );
};

export default ProjectMarquee;
